import request from '../utils/request';

// /rywise/website/news/page
export const newsPage = params => {
  return request({
    url: 'rywise/website/news/page',
    method: 'get',
    params
  })
}

// /rywise/website/information/addInformation
export const addInformation = params => {
  return request({
    url: 'rywise/website/information/addInformation',
    method: 'post',
    data:params
  })
}

// /rywise/website/news/selectByNewsIdQ
export const selectByNewsIdQ = params => {
  return request({
    url: 'rywise/website/news/selectByNewsIdQ',
    method: 'get',
    params
  })
}

// /rywise/pv/siteEnter
export const siteEnter = params => {
  return request({
    url: 'rywise/pv/siteEnter',
    method: 'post',
    params
  })
}